"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        textAlign: 'center',
        margin: 24
    },
    icon: {
        margin: 'auto',
        width: 350,
        marginBottom: 12
    },
    btn: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 18
    }
});
//# sourceMappingURL=oops.style.js.map